import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  uploadingDialog: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '150px',
    height: '150px',
  },
}));

export default useStyles;
